module.exports = __webpack_public_path__ + "DINNextLTPro-Heavy.woff?d5a55b21f0c3064776c313514e73265c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Heavy.woff
// module id = 1410
// module chunks = 0